import { render } from "./SixRightLayout.vue?vue&type=template&id=72881586&scoped=true"
import script from "./SixRightLayout.vue?vue&type=script&lang=js"
export * from "./SixRightLayout.vue?vue&type=script&lang=js"

import "./SixRightLayout.vue?vue&type=style&index=0&id=72881586&lang=scss&scoped=true"

import exportComponent from "/home/controlcenter/sourcecode/dubiverse/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72881586"]])

export default __exports__